import { useMemo } from 'react';

import { EMPTY_ARRAY } from '@e-socna/empty';

import type { ThirdPartiesCmp_SomeThirdParty } from '../queries/some-third-parties.query';

import { useFindAllDeletedExternalOrganizationsQuery } from './useFindAllDeletedExternalOrganizationsQuery.hook';
import { useFindAllDeletedExternalPeopleQuery } from './useFindAllDeletedExternalPeopleQuery.hook';

interface UnionResult {
  readonly data:
    | Readonly<{
        findSomeThirdParties: readonly ThirdPartiesCmp_SomeThirdParty[];
      }>
    | undefined;
  readonly isLoading: boolean;
  readonly isSuccess: boolean;
}

export const useFindAllDeletedExternalThirdPartiesQuery = (
  enabled = true,
): UnionResult => {
  const peopleQuery = useFindAllDeletedExternalPeopleQuery(enabled);
  const organizationsQuery =
    useFindAllDeletedExternalOrganizationsQuery(enabled);

  const memoizedResult = useMemo(() => {
    const peopleData = peopleQuery.data?.findSomePeople;
    const organizationsData = organizationsQuery.data?.findSomeOrganizations;

    const data =
      peopleData || organizationsData
        ? {
            findSomeThirdParties: [
              ...(peopleData ?? EMPTY_ARRAY),
              ...(organizationsData ?? EMPTY_ARRAY),
            ] as readonly ThirdPartiesCmp_SomeThirdParty[], // HACK : dirty,
          }
        : undefined;

    const isLoading = peopleQuery.isLoading || organizationsQuery.isLoading;
    const isSuccess = peopleQuery.isSuccess && organizationsQuery.isSuccess;

    return { data, isLoading, isSuccess };
  }, [
    organizationsQuery.data?.findSomeOrganizations,
    organizationsQuery.isLoading,
    organizationsQuery.isSuccess,
    peopleQuery.data?.findSomePeople,
    peopleQuery.isLoading,
    peopleQuery.isSuccess,
  ]);

  return memoizedResult;
};
